import SeamlessImmutable from 'seamless-immutable';
import { AgreementsActionsType } from './agreements.actions';
import AgreementsActionTypesEnum from './model/AgreementsActionTypesEnum';

export interface IAgreementsInterface {
  data: any[];
  acceptedAgreements: any[];
  filters: {
    serviceName?: string;
    [key: string]: any;
  };
}

const initialState = SeamlessImmutable<IAgreementsInterface>({
  data: [],
  acceptedAgreements: [],
  filters: {},
});

// eslint-disable-next-line import/no-anonymous-default-export
export default function(state: SeamlessImmutable.ImmutableObject<IAgreementsInterface> = initialState, action: AgreementsActionsType) {
  switch (action.type) {
    case AgreementsActionTypesEnum.SAVE_AGREEMENTS:
      return state.set('data', action.payload);
    case AgreementsActionTypesEnum.SAVE_ACCEPTED_AGREEMENTS:
      return state.set('acceptedAgreements', action.payload);
    case AgreementsActionTypesEnum.SET_AGREEMENT_FILTER:
      return state.setIn(['filters', action.payload.field], action.payload.value);
    case AgreementsActionTypesEnum.RESET_AGREEMENT_FILTERS:
      return state.set('filters', {});
    case AgreementsActionTypesEnum.RESET_AGREEMENTS:
      return initialState;
    default:
      return state;
  }
}

